<template>
  <app-modal name="e-invoice-account-modal" :title="title" @before-open="beforeOpen"  @before-close="beforeClose" @on-ok="onOk">
    <app-form
      ref="form"
      @on-submit="onSubmit"
      :schema="schema"
      :data="formModel"
    />
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import EInvoiceAccountProxy from '@/store/proxies/e-invoice-account-proxy';
import AppForm from '@/components/app-form/';

export default {
  name: 'ConnectEInvoiceAccountModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: this.$t('user.connectEInvoiceAccount'),
      formModel: {
        user_name: null,
        password: null,
        einvoice_provider: null,
      },
      schema: [
        {
          name: 'user_name',
          label: this.$t('user.username'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.username')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'password',
          label: this.$t('user.password'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.password')}`,
          inputType: 'password',
          type: 'input',
          validation: 'required|min:6',
        },
        {
          name: 'einvoice_provider',
          label: this.$t('user.eAccountProvider'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.eAccountProvider')}`,
          type: 'select',
          validation: 'required',
          options: [
            { value: 'E_VNPT', text: 'Vnpt' },
            { value: 'E_VIETTEL', text: 'Viettel' },
            { value: 'E_BKAV', text: 'Bkav' },
          ],
        },
      ],
    };
  },
  computed: {},
  methods: {
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          new EInvoiceAccountProxy().createEInvoiceAccount(formModel).then((response) => {
            this.$modal.hide('e-invoice-account-modal', { isOk: true });
            this.$bus.emit('e-invoice-account-created', response);
          });
        }
      });
    },
    beforeClose() {
      this.formModel = {
        user_name: null,
        password: null,
        einvoice_provider: null,
      };
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeOpen() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/e-invoice-account-modal.vue